import { useUserStore } from '@/store/userJWTStore';
import { useUserDataStore } from '@/store/userDataStore';
import { ActionPerformed, PushNotificationSchema, PushNotifications, Token } from '@capacitor/push-notifications'
import { Capacitor } from '@capacitor/core';
import { axiosLevelTech } from '../axiosConfig';

export const registerPushNotifications = () => {

  const isPushNotificationsAvailable = Capacitor.isPluginAvailable('PushNotifications');
  if (!isPushNotificationsAvailable) {
    console.log('Push notifications not available');
    return;
  }

  const userStore = useUserStore();
  const userDataStore = useUserDataStore();

  let hasBeenAskedForPush = localStorage.getItem('hasBeenAskedForPush') === 'true';

  //only request push if logged in and hasnt been asked before
  if (userStore.isLoggedIn && !hasBeenAskedForPush) {
    PushNotifications.requestPermissions().then(result => {
      if (result.receive === 'granted') {
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register();
      } else {
        // Show some error
      }
    });
  }

  // On success, we should be able to receive notifications
  PushNotifications.addListener('registration',
    (token: Token) => {
      console.log('Push registration success, token: ' + token.value);
      //send this token to the server along with personid 

      axiosLevelTech.post('api/notification/AddDeviceToken', {
        token: token.value,
        personId: userDataStore.userInfo?.personId
      }).then(response => {
        console.log('Push registration success, token sent to server');
        localStorage.setItem('hasBeenAskedForPush', 'true');
        //save the push token in local storage incase we need later
        localStorage.setItem('pushToken', token.value);
      }).catch(error => {
        console.log('Push registration success, token failed to send to server');
      });

    }
  );

  // Some issue with our setup and push will not work
  PushNotifications.addListener('registrationError',
    (error: any) => {
      console.log('Error on registration: ' + JSON.stringify(error));
    }
  );

  // Show us the notification payload if the app is open on our device
  PushNotifications.addListener('pushNotificationReceived',
    (notification: PushNotificationSchema) => {
      console.log('Push received: ' + JSON.stringify(notification));
    }
  );

  // Method called when tapping on a notification
  PushNotifications.addListener('pushNotificationActionPerformed',
    (notification: ActionPerformed) => {
      console.log('Push action performed: ' + JSON.stringify(notification));
      userDataStore.markNotificationsAsRead();
    }
  );

}
